import { t } from 'i18next';
import { useColorMode } from '@chakra-ui/react';
import { ReactComponent as ArrowTail } from '../../../icons/arrow.tail.svg';
import { BettieLetterStyle } from '../../../constants/BettieGradientColor';
import type { components } from '@pocapan/shared/types/schema';

type FanLetter = components['schemas']['ApiV1FanLetter'];

interface FanLetterLockOverlayProps {
  fanLetter: FanLetter;
}

const FanLetterLockOverlay = ({ fanLetter }: FanLetterLockOverlayProps) => {
  const { colorMode } = useColorMode();
  return (
    <div
      className="absolute inset-0 z-10 flex items-center justify-center"
      style={{
        backgroundImage: `url(/assets/bettie/bettie_letter_blur_${colorMode}.png)`
      }}
    >
      <div className="relative z-10 flex flex-col items-center justify-center gap-[16px]">
        <p className="text-[17px] font-bold text-text-main-lv2 text-center leading-[20px]">
          {t('BettieLetterDetail.readLetter', { nickname: fanLetter.bettieNickname })}
        </p>

        <div
          className="flex items-center gap-[12px] border border-[rgba(255,255,255,0.60)] rounded-[30px] px-[19px] pt-[9px] pb-[12px] shadow-[0_0_10px_0_rgba(0,0,0,0.03)]"
          style={BettieLetterStyle.priceBadgeBackground[colorMode]}
        >
          <div className="flex items-center gap-[4px]">
            <img
              src="/assets/icons/graphic-3d/3D.like.png"
              alt="heart"
              className="w-[24px] h-[24px]"
            />
            <div className="relative w-fit">
              <p className="text-[17px] font-semibold text-text-main-lv4 leading-[20px]">
                {t('BettieLetterDetail.count', { count: 5 })}
              </p>
              <div
                className="absolute top-1/2 left-1/2 h-[2px]"
                style={BettieLetterStyle.lineThrough[colorMode]}
              />
            </div>
          </div>
          <ArrowTail className="fill-text-main-lv4" width={20} height={20} />
          <div className="flex items-center gap-[4px]">
            <img
              src="/assets/icons/graphic-3d/3D.like.png"
              alt="heart"
              className="w-[24px] h-[24px]"
            />
            <p className="text-[20px] font-semibold text-text-main-lv2 leading-[24px]">
              {t('BettieLetterDetail.count', { count: 3 })}
            </p>
          </div>
        </div>

        <p className="text-[17px] font-semibold text-text-main-lv2 text-center leading-[20px]">
          {t('BettieLetterDetail.freeDescription')}
        </p>
        <p className="text-[15px] font-medium text-text-main-lv3 text-center leading-[18px]">
          {t('BettieLetterDetail.readLetterDescription', { nickname: fanLetter.bettieNickname })}
        </p>
      </div>
    </div>
  );
};

export default FanLetterLockOverlay;
